// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__acWZK","pageSize":"DataTableRemotePaging_pageSize__0Rrtt","selected":"DataTableRemotePaging_selected__76fAe"};